import { heroStats, mastheadMeta, liveReplies } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

const coverDigest = [
  { kicker: "01", text: "录音门完整时间线：三分证据、两处对不上" },
  { kicker: "02", text: "工作室声明逐句精读，留白比内容更精彩" },
  { kicker: "03", text: "被删动态备份公开，讨论区正在逐条核对" },
];

export default function Hero() {
  return (
    <section className="relative w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-10 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.6fr_1fr] lg:gap-14">
          <div className="rise-in">
            <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-600">
              <span className="flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 font-medium text-primary-700">
                <span className="live-dot h-1.5 w-1.5 rounded-full bg-primary-500" />
                今日封面
              </span>
              <span>{mastheadMeta.dateLabel}</span>
              <span className="hidden h-3 w-px bg-background-300 sm:inline-block" />
              <span>{mastheadMeta.issue}</span>
            </div>

            <h2 className="text-balance mt-6 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-5xl md:leading-[1.2]">
              今天的黑料社区，
              <br className="hidden sm:block" />
              从<span className="text-primary-600">一条被删的动态</span>讲到深夜的那份声明。
            </h2>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              黑料社区把今日热帖与爆料帖按热度摆在最前面，精华帖单独拉榜排序，最新回复实时滚动不断线。帖子讨论区支持跟帖、反驳与补充线索，
              一条线索进来，往往就是下一个反转的开始。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#download"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-download-2-line text-lg" />
                下载客户端，跟进更快
              </a>
              <a
                href="#trending"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-chat-3-line text-lg" />
                直接进入今日热帖
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-4 gap-y-6 border-t border-background-200 pt-6 sm:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <span className="flex h-5 w-5 items-center justify-center rounded bg-background-100 text-primary-600">
                      <i className={`${stat.icon} text-xs`} />
                    </span>
                    {stat.label}
                  </dt>
                  <dd className="mt-1.5 font-heading text-2xl font-bold text-foreground-950">{stat.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <Reveal className="lg:pt-2" delay={120}>
            <div className="flex flex-col gap-4">
              <figure className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <div className="h-[280px] w-full md:h-[360px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=abstract%20editorial%20magazine%20cover%20art%20with%20warm%20cream%20paper%20texture%2C%20crimson%20red%20ink%20brush%20strokes%20and%20subtle%20gold%20foil%20geometric%20lines%2C%20minimal%20artistic%20composition%2C%20soft%20studio%20lighting%2C%20elegant%20negative%20space%2C%20no%20text%2C%20tasteful%20warm%20palette%2C%20high%20detail&width=900&height=1200&seq=heiliaocom-hero-cover&orientation=portrait"
                    alt="黑料社区今日封面插画"
                    title="黑料社区今日封面 黑料社区热帖"
                    className="h-full w-full object-top"
                  />
                </div>
                <figcaption className="border-t border-background-200 px-5 py-4">
                  <span className="text-xs tracking-[0.25em] text-foreground-400">COVER STORY</span>
                  <p className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
                    一条线索如何撑起一整晚的讨论
                  </p>
                </figcaption>
              </figure>

              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
                  <i className="ri-list-check-2 text-primary-600" />
                  封面导读
                </h3>
                <ul className="mt-3 space-y-3">
                  {coverDigest.map((item) => (
                    <li key={item.kicker} className="flex gap-3">
                      <span className="font-heading text-sm font-bold text-accent-700">{item.kicker}</span>
                      <span className="text-sm leading-snug text-foreground-700">{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>

      <div className="w-full border-t border-background-200 bg-background-100">
        <div className="mx-auto flex w-full max-w-[1360px] items-center gap-4 px-4 py-3 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-medium text-primary-700">
            <span className="live-dot h-1.5 w-1.5 rounded-full bg-primary-500" />
            最新回复
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex w-max items-center gap-10">
              {[...liveReplies, ...liveReplies].map((reply, index) => (
                <span key={`${reply.id}-${index}`} className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-600">
                  <span className="font-medium text-foreground-800">{reply.author}</span>
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">{reply.action}</span>
                  <span>{reply.content}</span>
                  <span className="text-foreground-400">· {reply.time}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}